import { IS_TRACKING_ENABLED } from 'gatsby-env-variables'

import defaultParameters from './parameters/default'
import SDK from './setup'
import trackings from './trackings'

const resolveTrack = async (funcName = '', payload = {}) => {
  if (!IS_TRACKING_ENABLED) {
    return () => {}
  }

  const sdk = await SDK
  const getPayload = trackings[funcName](payload)
  if (funcName === 'setUserProperties') {
    sdk.setUserProperties({ analytics: getPayload })
  } else {
    sdk.track({ analytics: getPayload })
  }
}

const resolveSetup = async () => {
  if (!IS_TRACKING_ENABLED) {
    return () => {}
  }

  const sdk = await SDK
  sdk.setDefaultParameters({
    analytics: { parameters: defaultParameters }
  })
}

export default {
  setup: resolveSetup,
  track: (funcName = '', payload = {}) => resolveTrack(funcName, payload)
}
